import { useState } from 'react';
import { t, useLocale } from '../lib/i18n.js';
import { analyticsEnabled, setAnalyticsEnabled } from '../lib/analytics.js';

export function Privacy() {
  useLocale();
  const [enabled, setEnabled] = useState(analyticsEnabled);
  return (
    <main className="page reading-page">
      <p className="eyebrow">{t('Your choices', 'あなたの設定')}</p>
      <h1>{t('Play without an account.', 'アカウントなしで遊べます。')}</h1>
      <p>
        {t(
          'Last updated: September 13, 2026. Operated by phunter_jp.',
          '更新日: 2026年9月13日。運営: phunter_jp。',
        )}
      </p>
      <section>
        <h2>{t('What stays on your device', '端末に保存するもの')}</h2>
        <p>
          {t(
            'Your language, optional nickname, room access tokens, sound settings and recent solo attempts are stored in your browser. Solo answers stay on your device unless you enable usage sharing. You can clear these using your browser’s site-data settings; doing so also removes access to rooms you created.',
            '表示言語、任意の名前、部屋へのアクセストークン、音声設定、最近の一人用プレイ記録をブラウザに保存します。利用状況の共有を許可しない限り、一人用の回答は端末に留まります。ブラウザのサイトデータ設定から削除できますが、作成した部屋へのアクセスも失われます。',
          )}
        </p>
      </section>
      <section>
        <h2>{t('Hosted games', 'ホスト式のゲーム')}</h2>
        <p>
          {t(
            'The game server receives your display name, connection and answers to run the room and calculate scores. Other players in the room can see your display name and results. Room and game records are stored on the server. Use a nickname, and avoid entering personal information in your display name. Contact the operator about stored game records.',
            '進行と得点計算のため、サーバーは表示名、接続、回答を受け取ります。同じ部屋の参加者には表示名や結果が見えます。部屋とゲームの記録はサーバーに保存されます。表示名には個人情報を含めず、ニックネームをお使いください。保存されたゲーム記録については運営へご連絡ください。',
          )}
        </p>
      </section>
      <section>
        <h2>{t('Optional usage sharing', '任意の利用状況の共有')}</h2>
        <p>
          {t(
            'Off by default. If you enable it, we collect a random browser ID, session ID, broad referral source, language, device type, and events such as starting, completing or sharing a round. This helps find broken audio and confusing steps. We do not send your nickname, room tokens, full referrer URL or microphone audio to this measurement endpoint. No advertising trackers are used.',
            '初期状態はオフです。許可した場合、ランダムなブラウザIDとセッションID、おおまかな流入元、言語、端末の種類、開始・完了・共有などのイベントを収集します。音声の不具合や分かりにくい操作を改善するために使います。表示名、ルームトークン、流入元の完全なURL、マイク音声は計測先に送りません。広告トラッカーは使いません。',
          )}
        </p>
        <label className="privacy-choice">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(event) => {
              setAnalyticsEnabled(event.target.checked);
              setEnabled(analyticsEnabled());
            }}
          />
          {t(
            'Share anonymous usage to help improve the game',
            'ゲーム改善のために匿名の利用状況を共有する',
          )}
        </label>
        <p className="muted small">
          {t(
            'Turning this off stops future events and removes the local measurement ID. Do Not Track is respected. Measurements and form feedback are limited to the latest 30 days and cleaned up periodically; reports cover opted-in browsers only.',
            'オフにすると以後の送信を停止し、端末の計測IDを削除します。Do Not Trackにも対応します。計測データとフォームのご意見は直近30日分に制限し、定期的に整理します。集計は許可したブラウザのデータのみです。',
          )}
        </p>
      </section>
      <section>
        <h2>{t('Hosting, audio and shared links', 'ホスティング・音声・共有リンク')}</h2>
        <p>
          {t(
            'Cloudflare serves the game and processes normal network request data for delivery and security. Recorded English audio is served from this site. Experimental generated rounds may use browser speech synthesis and an AI provider for game content; no player voice recording is needed. Shared challenge links contain a challenge ID, language and random referral code, not your name or the answer.',
            'Cloudflareがゲームを配信し、配信やセキュリティのため通常の通信情報を処理します。同梱の英語音声はこのサイトから配信します。実験的な生成問題ではブラウザの読み上げやAI提供元を使う場合がありますが、参加者の音声録音は不要です。挑戦状リンクに含まれるのは問題ID、言語、ランダムな紹介コードで、名前や正解は含みません。',
          )}
        </p>
      </section>
      <section>
        <h2>{t('Questions or data requests', 'ご質問・データについて')}</h2>
        <p>
          {t(
            'Contact the operator on X. Please include the room code and approximate date for questions about a hosted game, but never send room access tokens.',
            '運営のXへご連絡ください。ホスト式ゲームについては部屋のコードとおおよその日時を添えてください。アクセストークンは送らないでください。',
          )}{' '}
          <a href="https://x.com/phunter_jp" target="_blank" rel="noreferrer">
            @phunter_jp ↗
          </a>
        </p>
      </section>
    </main>
  );
}
